import { HeadingH5, Flex, Button } from '@hausgold/designsystem';
import { ArrowRightDrop } from '@hausgold/designsystem/icons';
import FluidMaxContainer from '../../FluidMaxContainer.js';
import RendererLayoutContainer from '../../Layouts/RendererLayoutContainer.js';
import PropTypes from 'prop-types';
import 'react';
import { jsx } from '@emotion/react';
var ExtendedStart = function ExtendedStart(_ref) {
  var handleRedirect = _ref.handleRedirect,
    handleGoForward = _ref.handleGoForward;
  return jsx(FluidMaxContainer, null, jsx(RendererLayoutContainer, null, jsx(HeadingH5, {
    fontWeight: "semibold",
    fontSize: {
      base: 'xl',
      md: '2xl'
    },
    mx: {
      base: 0,
      md: 10
    },
    mb: 6,
    textAlign: "center"
  }, "F\xFCr die kostenlose Immobilienbewertung vor Ort ermitteln wir f\xFCr Sie den passenden Immobilienexperten.", jsx("br", null), "Dazu ben\xF6tigen wir noch einige Daten."), jsx(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, jsx(Button, {
    id: "button--extended-continue",
    variant: "primary",
    mb: 1,
    onClick: function onClick() {
      handleGoForward('weiter');
    },
    width: "156px"
  }, "Weiter", jsx(ArrowRightDrop, {
    boxSize: 2.5,
    ml: {
      base: 1.5,
      md: 2.5
    }
  })), jsx(Button, {
    id: "button--extended-skip",
    variant: "ghost",
    as: "a",
    borderRadius: "circle",
    width: "156px",
    onClick: handleRedirect
  }, "\xDCberspringen"))));
};
ExtendedStart.propTypes = {
  handleRedirect: PropTypes.func.isRequired,
  handleGoForward: PropTypes.func.isRequired
};
export { ExtendedStart as default };